<template>
  <div class="main-body">
    <div class="main-panel" style="height: 800px">
      <div class="main-content-wrap">
        <a-row>
          <a-col :span="24">
            <a-table
              row-key="id"
              :loading="table.loading"
              :data-source="table.data"
              :pagination="false"
              @change="handleTableChange"
              ref="table.dataRef">
<!--              <a-table-column-->
<!--                :sorter="true"-->
<!--                key="order.warningReason"-->
<!--                data-index="order.warningReason" title="预警原因" width="120">-->
<!--              </a-table-column>-->
              <a-table-column
                align="center"
                key="name"
                data-index="name" title="物流名称" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                key="collectTime"
                data-index="collectTime" title="揽收时间" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                key="collectDate"
                data-index="collectDate" title="是否当天" width="120">
                <template slot-scope="text, record">
                  {{ record.collectDate === null?'':record.collectDate !== '0' ? '次日':'当日'}}
                </template>
              </a-table-column>
              <a-table-column
                align="center"
                key="sendTime"
                data-index="sendTime" title="发货最大时限(小时)" width="120">
              </a-table-column>
              <a-table-column title="操作" width="350" align="center">
                <template slot-scope="text, record">
                  <a-button @click="edit(record)" v-has="'AREA_EDIT'" type="link" size="small">编辑</a-button>
                </template>
              </a-table-column>
            </a-table>

          </a-col>
        </a-row>
      </div>

    </div>
    <a-modal v-model="dialogShow" width="600px" @cancel="onFormCancel" @ok="onFormSave" :destroy-on-close="true" title="编辑物流信息">
      <logistics-edit :form="form"
                      ref="logisticsEdit"
                      :on-cancel-handler="onFormCancel"
                      :on-save-handler="onFormSave"></logistics-edit>
    </a-modal>
  </div>
</template>

<script>

import {getExpressList} from "../../../api/express";
import LogisticsEdit from "./LogisticsEdit";

export default {
  name: "Logistics",
  components: { LogisticsEdit },
  data() {
    return {
      table: {
        loading: false,
        data: [],
        // pagination: {
        //   current: 1,
        //   pageSize: 3,
        //   total: 0,
        //   showSizeChanger: true,
        //   pageSizeOptions: ['3', '10', '20', '40', '50'],
        //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        // },
        // sort: {
        //   prop: 'launchTime',
        //   order: 'descend',
        // },
      },
      dialogShow: false,
      form: {}
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await getExpressList();
      if (res.code === 1200) {
        this.table.data = res.data.express;
      }
    },
    add() {
      this.dialogShow = true
    },
    edit(record) {
      console.log(record)
      this.form = record;
      this.dialogShow = true
    },
    onFormSave() {
      this.dialogShow = false;
      this.$refs.logisticsEdit.submit();
      this.getList();
      this.form = {};
    },
    onFormCancel() {
      this.dialogShow = false;
      this.getList();
      this.form = {};
    }
  }
}
</script>

<style scoped>

</style>
